import { Period } from '../../Interface/Interest/Period';

export const calculateTotal = (period: Period): number => {
    let total = period.period / 12;

    if (period.subPeriod !== undefined) {
        total += (period.subPeriod / 12);
    }

    return total;
}

export const getIdentifier = (period: Period): string => {
    let identifier = `${period.period}`;

    if (period.subPeriod !== undefined) {
        identifier += `+${period.subPeriod}`;
    }

    return identifier;
}

export const getLabel = (period: Period): string => {
    if (period.period === 1) {
        return 'Variabel';
    }

    const total = calculateTotal(period);

    let subPeriod = '';

    if (period.subPeriod !== undefined) {
        subPeriod = ` (${period.period / 12} + ${period.subPeriod / 12})`;
    }

    return `${total}${subPeriod} jaar`;
}

export const sortByPeriod = (periodA: Period, periodB: Period): number => {
    const totalA = calculateTotal(periodA);
    const totalB = calculateTotal(periodB);
    if (totalA !== totalB) {
        return totalA > totalB ? 1 : -1;
    }

    if (periodA.period !== periodB.period) {
        return periodA.period < periodB.period ? 1 : -1;
    }

    if (periodA.subPeriod === periodB.subPeriod) {
        return 0;
    }

    const subPeriodA = periodA.subPeriod !== undefined ? periodA.subPeriod : 0;
    const subPeriodB = periodB.subPeriod !== undefined ? periodB.subPeriod : 0;
    return subPeriodA > subPeriodB ? 1 : -1;
}

export const arePeriodsEqual = (periodA: Period, periodB: Period): boolean =>
    periodA.period === periodB.period && periodA.subPeriod === periodB.subPeriod;

export const arePeriodArraysEqual = (a: Period[], b: Period[]): boolean =>
    JSON.stringify([...a].sort(sortByPeriod)) === JSON.stringify([...b].sort(sortByPeriod));

const destructIdentifier = (identifier: string): Period => {
    const period: Period = {
        period: 1,
        subPeriod: undefined,
    }
    const data = identifier.split('+');

    if (data === null) {
        return period;
    }

    period.period = parseInt(data[0]);

    if (data.length > 1) {
        period.subPeriod = parseInt(data[1]);
    }

    return period;
}

export const getLabelByIdentifier = (identifier: string): string => getLabel(destructIdentifier(identifier));
